import { render, staticRenderFns } from "./HotelsSearchBanner.vue?vue&type=template&id=98c6cf6e&"
import script from "./HotelsSearchBanner.vue?vue&type=script&lang=ts&"
export * from "./HotelsSearchBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c6cf6e')) {
      api.createRecord('98c6cf6e', component.options)
    } else {
      api.reload('98c6cf6e', component.options)
    }
    module.hot.accept("./HotelsSearchBanner.vue?vue&type=template&id=98c6cf6e&", function () {
      api.rerender('98c6cf6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/HotelsSearchBanner.vue"
export default component.exports